/**
 * @jest-environment jsdom
 */

import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";

const initialState = {};
const middleware = [thunk];

// debug redux - Use to show all interaction of the reducers on the console.
const debug = false;

if (debug) {
    const logger = createLogger({
        predicate: false,
        collapsed: true,
        duration: true,
    });
    middleware.push(logger);
}

let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
);

/* Test hook: e2e specs dispatch a signed-in user to exercise gated UI without a
   real Azure login. Absent from production builds (REACT_APP_ENVIRONMENT=pro). */
if (process.env.REACT_APP_ENVIRONMENT !== "pro") {
    window.__CULTEC_STORE__ = store;
}

export default store;



// WEBPACK FOOTER //
// ./src/store.js